<template>
        <BreadCrumb PageTitle=" Ajouter une reclamation" />
    <AddReclamation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddReclamation from "@/components/Reclamation/AddReclamation.vue";
  
    export default defineComponent({
      name: "AddReclamationPage",
      components: {
        BreadCrumb,
        AddReclamation,
      },
    });
  </script>